import { useState } from "react";
import { useTranslation } from "@coworker/locales";
import { Store } from "../../shared/types/store";
import { StoreEnvironmentSelector } from "../../home/components/Profile/StoreEnvironment/StoreEnvironmentSelector";
import { SwitcherSheet } from "../../home/components/Profile/StoreEnvironment/SwitcherSheet";
import FixaInlineMessage from "../../shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import InformationCircleIconPath from "../../shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import LinkOutIconPath from "../../shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import FixaSSRIcon from "../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { MY_IDENTITY_STORE_REQUEST_URL } from "@coworker/consts/myIdentityLinks";

interface StoreSwitcherProps {
  labelKey: string;
  activeStore: Store;
  stores: Store[];
  loading: boolean;
  handleSwitchStore: (storeId: string) => void;
}

const StoreSwitcher = ({
  labelKey,
  activeStore,
  stores,
  loading,
  handleSwitchStore,
}: StoreSwitcherProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const missingStoreInfoNode = (
    <FixaInlineMessage
      ssrIcon={InformationCircleIconPath}
      title={t("missingStoreString")}
      body={t("missingStoreBodyString")}
      variant="informative"
      actions={[
        {
          text: (
            <>
              {t("myIdentityString")}
              <FixaSSRIcon paths={LinkOutIconPath} />
            </>
          ),
          onClick: () =>
            window.open(
              MY_IDENTITY_STORE_REQUEST_URL,
              "_blank",
              "noopener,noreferrer"
            ),
        },
      ]}
    />
  );

  return (
    <>
      <StoreEnvironmentSelector
        id="team-management-store-selector"
        value={
          !activeStore?.name
            ? t("chooseAnOptionString")
            : `${activeStore.storeId} - ${activeStore.name}`
        }
        label={labelKey}
        validationMsg="pleaseSelectAStoreString"
        selectedItem={activeStore}
        loading={loading}
        onClick={() => setIsOpen(true)}
      />

      <SwitcherSheet
        titleKey={labelKey}
        placeholderKey="searchStoreString"
        items={stores}
        selectedItem={activeStore}
        getItemLabel={(store) => `${store.storeId} - ${store.name}`}
        getItemKey={(store) => store.storeId}
        onSelect={(store) => handleSwitchStore(store.storeId)}
        loading={loading}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        infoNode={missingStoreInfoNode}
      />
    </>
  );
};

export default StoreSwitcher;
